import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type DeleteWorkflowRuleMutationVariables = GraphQLTypes.Exact<{
  workflowRuleId: GraphQLTypes.Scalars['String']['input'];
}>;

export type DeleteWorkflowRuleMutationResult = { __typename?: 'Mutation' } & {
  deleteWorkflowRule?: GraphQLTypes.Maybe<
    { __typename?: 'DeleteWorkflowRulePayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const DeleteWorkflowRuleDocument = gql`
  mutation deleteWorkflowRule($workflowRuleId: String!) {
    deleteWorkflowRule(workflowRuleId: $workflowRuleId) {
      errors {
        message
        path
      }
    }
  }
`;
